'use client';

import { PaybackPage } from '@packages/order/src/components/Payback/PaybackPage.client';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  paybackHeadline: {
    defaultMessage: 'Mein PAYBACK',
    id: 'Payback.Headline',
  },
});

export const PaybackPageClient = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <h1>{formatMessage(messages.paybackHeadline)}</h1>
      <PaybackPage />
    </>
  );
};
